import { Spinner } from "flowbite-react";

const PreparePrint = ({ isPrinting }) => {
  return (
    <>
      {isPrinting && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center">
          <div className="bg-white px-6 py-5 rounded-2xl shadow-lg text-center max-w-sm w-full">
            <div className="text-xl font-semibold text-gray-800 mb-2">
              Preparando a mágica ✨
            </div>
            <div className="text-sm text-gray-600">
              Só um segundinho... estamos preparando sua impressão!
            </div>
            <Spinner size="lg" color="success" className="mt-2" />
          </div>
        </div>
      )}
    </>
  );
};

export default PreparePrint;
